import { useMemo } from 'react';

import type { MenuItem } from '@/consts/navigation';
import { cn } from '@/utils/cn';

import { NavMenuItemRow } from './NavMenuItemRow';

interface NavMenuItemsListProps {
  items: MenuItem[];
  variant?: 'expanded' | 'popover';
  isUtilitySection?: boolean;
}

export const NavMenuItemsList = ({ items, variant = 'expanded', isUtilitySection = false }: NavMenuItemsListProps) => {
  const isPopover = variant === 'popover';

  // Filter out hidden items (used for breadcrumbs only)
  const visibleItems = useMemo(() => items.filter((item) => !item.hidden), [items]);

  return (
    <ul className={cn('bg-background-250 flex flex-col gap-1 p-1')} role="menu">
      {visibleItems.map((childItem) => (
        <NavMenuItemRow
          key={childItem.text}
          childItem={childItem}
          isPopover={isPopover}
          isUtilitySection={isUtilitySection}
        />
      ))}
    </ul>
  );
};
